import React from "react";
import type { TabOrderItem } from "../../../../services/settings";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Paper } from "@mui/material";
import styles from "../../styles";
import useCss from "../../../../hooks/useCss";
import SbuxTranslate from "../../../SbuxTranslate";

interface Props {
  element: TabOrderItem;
}

const DragElement = ({ element }: Props) => {
  const classes = useCss(styles);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: element.tabId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  if (!element.visible) {
    return null;
  }

  return (
    <Box className={classes.elementRoot}>
      <Paper
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        sx={{
          background: "rgb(242, 242, 242)",
          border: "1px solid rgba(0, 0, 0, 0.05)",
          borderTopRightRadius: "5px",
          borderTopLeftRadius: "5px",
          fontSize: 16,
          minWidth: "14.25vw",
          minHeight: "3.5vh",
          marginBottom: 1,
          cursor: "grab",
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <div className={classes.elementTabName}>
          <SbuxTranslate>{element.label}</SbuxTranslate>
        </div>
      </Paper>
    </Box>
  );
};

export default React.memo(DragElement);
